export const environment = {
  production: false,
  // Login de Diazar Cloud (Firebase Authentication del proyecto diazar-cloud-dev).
  // La API key es la clave pública web del proyecto; la restringen los referrers autorizados.
  identityFirebase: {
    apiKey: 'AIzaSyDxXN6SIdfhD-naWvYXPwcQxr3HYTd2Kn4',
    authDomain: 'diazar-cloud-dev.firebaseapp.com',
    projectId: 'diazar-cloud-dev',
    appId: '1:638968608521:web:ae0fbea311b7180d3105d8',
  } as { apiKey: string; authDomain: string; projectId: string; appId: string } | null,
  federatedLogin: { microsoft: true, apple: true, microsoftTenant: 'common' },
  // dcw-residentes usa obra-backend (dcw-residentes-go-backend); diazar-requisitions-dev ya corre otro servicio.
  baseURL: 'https://obra-backend-dev-969075189623.us-central1.run.app/api',
  // La detección de sesiones múltiples dependía del flujo Auth0; queda apagada hasta definir quién escribe las sesiones.
  singleSessionCheck: false,
  usersControlUrl: 'controldeusuarios.qa.diazar.com/user-info',
  firebaseConfig :{
    apiKey: "AIzaSyBIaorKWhEmK_R2c5aGRqzpOapiyknsIGw",
    authDomain: "diazarcontrol-2ac23.firebaseapp.com",
    projectId: "diazarcontrol-2ac23",
    storageBucket: "diazarcontrol-2ac23.firebasestorage.app",
    messagingSenderId: "958696246802",
    appId: "1:958696246802:web:8803234b1ad049ea43d2cb",
    measurementId: "G-FWD3VK91EP"
  },
  environment: 'develop',
  mixpanelToken: '76c124ad4cece5c2a34559070d3b4381'
}
